import React, { useEffect, useState } from 'react';
import { Modal, Table, message } from 'antd';
import Axios from 'axios';
import moment from 'moment';

const DetailAdjustSPStockSupplier = ({ isVisible, onCancel, record, pageSize: initialPageSize, token, selectedMonth, userRole, selectedSupplier, url }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState({
    sort: 'created_at',
    order: 'descend',
  });

  useEffect(() => {
    if (isVisible && record) {
      fetchAdjustData(record.before_item, record.model, record.created_at, page);
    }
  }, [isVisible, record, page, sort]);

  const fetchAdjustData = async (itemNumber, model, created_at, currentPage, perpage = 10) => {
    setLoading(true);

    try {
      const params = {
        item_number: itemNumber,
        model: model,
        created_at: created_at,
        page: currentPage,
        perpage: perpage,
        sort: sort.sort,
        order: sort.order,
        year: selectedMonth?.format('YYYY'),
        month: selectedMonth?.format('MM'),
      };

      if (userRole !== 'admin') {
        params.supplier = selectedSupplier?.code;
      }

      const res = await Axios.get(`${url}/stock-inventory/getDetailAdjust`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setData(res.data.data);
      setTotal(res.data.total);
    } catch (err) {
      message.error('Gagal mengambil data detail adjust');
    } finally {
      setLoading(false);
    }
  };

  const handleChangeTable = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setSort({
      sort: sorter.field,
      order: sorter.order,
    });
  };

  const columns = [
    {
      title: 'Adjust Date',
      dataIndex: 'created_at',
      sorter: true,
      render: (text) => moment(text).format('DD-MM-YYYY HH:mm'),
    },
    {
      title: 'Adjust Qty',
      dataIndex: 'qty_adjust',
      sorter: true,
      render: (value) => (value > 0 ? `+${value}` : value < 0 ? `${value}` : '0'),
    },
    {
      title: 'Adjusted By',
      dataIndex: 'adjusted_by',
      sorter: true,
    },
    {
      title: 'Reason',
      dataIndex: 'keterangan_parsed',
      sorter: true,
    },
  ];

  return (
    <Modal visible={isVisible} onCancel={onCancel} title={data.length > 0 ? `Detail Adjust Stock ${data[0].item_number}` : 'Detail Adjust Stock'} footer={null} width="80%">
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        onChange={handleChangeTable}
        pagination={{
          current: page,
          total: total,
        }}
        rowKey={(row) => row._id}
      />
    </Modal>
  );
};

export default DetailAdjustSPStockSupplier;
